import { render, staticRenderFns } from "./page5.vue?vue&type=template&id=61968ef8&scoped=true&"
import script from "./page5.vue?vue&type=script&lang=js&"
export * from "./page5.vue?vue&type=script&lang=js&"
import style0 from "./page5.vue?vue&type=style&index=0&id=61968ef8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61968ef8",
  null
  
)

export default component.exports